const PropTypes = require('prop-types');
const React = require('react');
const ShippingRegionOption = require('./shipping_region_option');
const {
  map,
  find,
  filter,
  includes,
  flatten,
  reject,
  sortBy,
  uniq,
  union,
  indexOf
} = require('lodash');

const EVERYWHERE_ELSE_REGION_TYPE = 'everywhere_else';
const SUPERREGION_REGION_TYPE = 'superregion';
const COUNTRIES_WITH_SUBREGION_CODES = ['US'];
const TOP_REGION_CODES = ['US', 'CA', 'GB', 'AU', 'FR', 'DE', 'JP', 'RU', 'ID'];

class ShippingRegionSelector extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    $(this.shippingRegionSelect).change(() => this.onChange());
  }

  componentDidUpdate() {
    if (!this.props.newShippingRate.regionCode) {
      $(this.shippingRegionSelect).find('option').first()
        .attr('selected', true);
    }

    $(this.shippingRegionSelect).trigger('liszt:updated');
  }

  onChange(e) {
    $(this.shippingRegionSelect).blur();

    const selectedRegionCode = this.selectedShippingRegionCode(e);

    let selectedRegion = {};

    if (selectedRegionCode) {
      selectedRegion = find(this.allShippingRegions, (region) =>
        region.code === selectedRegionCode
      );
    }

    this.props.onChange(selectedRegion);
  }

  // workaround for tests, where chzn is stubbed
  selectedShippingRegionCode(event) {
    if (event && event.target) {
      return event.target.value;
    }

    return this.shippingRegionSelect.value;
  }

  prompt() {
    return <option value={''}>{I18n.t('shippingRates.shippingRegionPlaceholder')}</option>;
  }

  regionOptGroup(regions) {
    const regionsWithoutShippingRate = reject(regions, (region) =>
      find(this.props.shippingRates, (shippingRate) =>
        shippingRate.regionType === region.region_type &&
          shippingRate.regionCode === region.code
      )
    );

    return (
      <optgroup>
        {
          regionsWithoutShippingRate.map((shippingRegion) =>
            <ShippingRegionOption
              key={shippingRegion.code}
              shippingRegion={shippingRegion}
            />
          )
        }
      </optgroup>
    );
  }

  everywhereElseOptGroup() {
    return this.regionOptGroup(this.everywhereElse);
  }

  topRegionsOptGroup() {
    return this.regionOptGroup(this.topRegions);
  }

  superRegionsOptGroup() {
    return this.regionOptGroup(this.superRegions);
  }

  subRegionsOptGroup() {
    return this.regionOptGroup(this.subRegions);
  }

  countriesOptGroup() {
    return this.regionOptGroup(this.countriesWithoutTopRegions);
  }

  get everywhereElse() {
    return filter(this.props.shippingRegions, (region) =>
      region.region_type === EVERYWHERE_ELSE_REGION_TYPE
    );
  }

  get topRegions() {
    const unsortedTopRegions = filter(this.countries, (country) =>
      includes(TOP_REGION_CODES, country.code)
    );

    return sortBy(unsortedTopRegions, (country) =>
      indexOf(TOP_REGION_CODES, country.code)
    );
  }

  get superRegions() {
    return filter(this.props.shippingRegions, (region) =>
      region.region_type === SUPERREGION_REGION_TYPE
    );
  }

  get subRegions() {
    const countriesWithSubregions = filter(this.countries, (country) =>
      includes(COUNTRIES_WITH_SUBREGION_CODES, country.code)
    );

    return flatten(map(countriesWithSubregions, (country) => country.children));
  }

  get countriesWithoutTopRegions() {
    return filter(this.countries, (country) =>
      !includes(TOP_REGION_CODES, country.code)
    );
  }

  get countries() {
    const allCountries = flatten(
      map(this.superRegions, (superRegion) =>
        superRegion.children
      )
    );

    const sortedCountries = sortBy(allCountries, (country) =>
      country.name
    );

    const isSorted = true;

    // some countries are in 2 superregions, like Turkey
    return uniq(sortedCountries, isSorted, (country) => country.code);
  }

  get allShippingRegions() {
    return union(
      this.everywhereElse,
      this.topRegions,
      this.superRegions,
      this.subRegions,
      this.countries
    );
  }

  render() {
    return (
      <select
        className="no-text-optgroups"
        ref={(el) => { this.shippingRegionSelect = el; }}
        value={this.props.newShippingRate.regionCode}
        onChange={this.onChange}
      >
        {this.prompt()}
        {this.everywhereElseOptGroup()}
        {this.topRegionsOptGroup()}
        {this.superRegionsOptGroup()}
        {this.subRegionsOptGroup()}
        {this.countriesOptGroup()}
      </select>
    );
  }
}

ShippingRegionSelector.propTypes = {
  shippingRegions: PropTypes.array.isRequired,
  shippingRates: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  newShippingRate: PropTypes.object.isRequired,
};

module.exports = ShippingRegionSelector;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_rates/shipping_region_selector.jsx